import { render, staticRenderFns } from "./my-schedule-add-score-modal.vue?vue&type=template&id=51939750"
import script from "./my-schedule-add-score-modal.vue?vue&type=script&lang=js"
export * from "./my-schedule-add-score-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports